const swiperHelp = new Swiper('.swiper-help-page', {
    direction: 'horizontal',
    loop: false,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: true
    },
    spaceBetween: 20,
    breakpoints: {
        320: {
            slidesPerView: 1
        },
        768: {
            slidesPerView: 1
        },
        1023: {
            slidesPerView: 4
        }
    }
});

$( ".tabs-item .tabs-widget .list a" ).click(function() {
    var current_tab = $(this).closest('.tabs-item').attr('id');
    var current_data = $(this).data('target');
    $('#'+current_tab).find('.tabs-widget a').removeClass("active");
    $(this).addClass("active");
    $('#'+current_tab).find(".tabs-inner").css("display","none");
    $('#'+current_tab).find('#'+current_data).css("display","block");

});

$(".help-page .head input").keyup(function() {
    var input = $(this);
    if( input.val() == "" ) {
        $('.help-page .head .search-box').css('visibility','hidden');
        $('.help-page .head .search-box').css('opacity','0');
    }else{
        $('.help-page .head .search-box').css('visibility','visible');
        $('.help-page .head .search-box').css('opacity','1');
    }
});